import React from 'react'

import { Box, Typography } from '@mui/material'
import NoPhotographyIcon from '@mui/icons-material/NoPhotography'

const ImagePlaceholder = ({ ...rest }) => (
  <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" width="100%" {...rest}>
    <Typography variant="subtitle2" textAlign="center">
      No exception
      <br />
      images attached
    </Typography>
    <NoPhotographyIcon color="action" fontSize="large" />
  </Box>
)

export default ImagePlaceholder
